import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable ,  forkJoin } from 'rxjs';
import { Injectable } from '@angular/core';
import { ProductViewDataService } from './product-view-data.service';
import { ApiGatewayHelperService } from './../../app/services/apigateway-helper.service';
import { AuthService } from '../../app/services/auth.service';
import { AppHelperService } from 'modules/app/services/app-helper.service';
import { UserSettingsService } from './user-settings.service';
import { map } from 'rxjs/operators';


@Injectable()
export class TeacherProductViewResolverService  {
    constructor(private authService: AuthService,
        private productViewDataService: ProductViewDataService,
        private appHelperService: AppHelperService,
        private apiGatewayHelperService: ApiGatewayHelperService,
        private userSettingsService: UserSettingsService) { }
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.apiGatewayHelperService.setSpaceId(route.params.spaceid);
        let userData = this.authService.getUserData();
        let productCode = route.params.productcode;
        let classId = route.params.classid;
        let assignmentId = route.params.assignmentid;
        let learnerDlsId = route.params.userid;
        let unitCode = route.params.unitcode;
        let activityId = route.params.activityId;
        let stage, lgid;
        // class details are needed when a saved or bookmarked URL of a deleted class is being accessed
        // hence setting fetchClassDetails to true if classId is present in the URL params
        let fetchClassDetails = !!route.params.classid;

        //Send Stage url in case of builder preview
        if(route.queryParams.preview && route.queryParams.stage) {
            stage = route.queryParams.stage;
        }
        lgid = route.queryParams.ltiGiId;
        if (!route.queryParams.preview) {

            // This code was commented out as part of NEMO-18877.
            // We need to fetch class details for deleted classes, but this block was preventing that.
            // It was preventing class details from being fetched when there was no assignmentId
            // and getLearnerUA was not true.

            // if (!assignmentId && !route.data.getLearnerUA) {
            //    class details are needed only when an assignment is being viewed
            //     fetchClassDetails = false;
            // }
            
            const accessToExpiredProduct = this.appHelperService.isProductReviewMode();
            const productViewObs = this.productViewDataService.fetchAndStoreProductViewData({ productCode, classId, assignmentId, learnerDlsId, unitCode, activityId, accessToExpiredProduct, fetchClassDetails, lgid }, false, route.data.getLearnerUA).toPromise().then((productData: any) => {
                
                if (productData && productData.success === false) {
                    if(productData.error == 'ASSIGNMENT_DOES_NOT_EXIST'){
                        this.appHelperService.navigateToOnboardingApp(['lti-onboarding-error', 'asssignmentDoesNotExist']);
                        return;
                    }
                    this.appHelperService.showLoaderAndNavigateToDashboard(userData);
                    return;
                }
                // NEMO-6677 : navigate away to dashboard as the product is suppressed.
                let bundleDetails = productData['bundleDetails'];
                let product = bundleDetails && bundleDetails.products && bundleDetails.products.find( (bundle) => bundle['dls-product'] && bundle['dls-product'].code === productCode);
                let suppressedLP = this.productViewDataService.isProductSuppressed(product, 'hide-learning-path', route.params.spaceid);
                let suppressedAssignment = assignmentId && this.productViewDataService.isProductSuppressed(product, 'hide-assignments', route.params.spaceid);
                let isAssignmentRoute = (state.url.includes("assignment") || assignmentId);
                if (isAssignmentRoute && suppressedAssignment) {
                    this.appHelperService.navigateToDashboardApp([]);
                } else if (!isAssignmentRoute && (userData && userData.launchType != 'lti' && suppressedLP)) {
                    this.appHelperService.navigateToDashboardApp([]);
                }
                
                return {
                    'userProfileData': userData,
                    'productData': productData
                }
            });
            const tocSettingsObs = this.userSettingsService.getTOCSettingsForUser({spaceId: route.params.spaceid, classId: route.params.classid, productCode: productCode});
            return forkJoin(productViewObs, tocSettingsObs).pipe(
                map(response => {
                    const productViewOData = response[0];
                    productViewOData['userSettingsData'] = response[1];
                    return productViewOData;
                })
            );
        } else {
            return this.productViewDataService.fetchAndStoreProductPreviewData(productCode, stage).toPromise().then((productData: any)=> {
                return {
                    'userProfileData': userData ? userData : { extUserId: 'dummyuserid' },
                    'productData': productData
                }
            });
        }        
    }
}
